const parseBooleanFlag = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value == null) {
    return defaultValue;
  }

  const normalized = value.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }
  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }

  return defaultValue;
};

export const REGISTRATION_DISCOUNT_PROGRAM_ENABLED = parseBooleanFlag(
  import.meta.env.VITE_REGISTRATION_DISCOUNT_PROGRAM_ENABLED,
  false,
);
